import React from 'react';
import Link from 'next/link';
import Icon from '@common/assets';
import InfoDetailArticleVideo from '../video/InfoDetailArticleVideo';
import InfoDetailArticleShareGroup from '../shareGroup';
import { InfoDetailVO } from '@domain/vo/info/infoDetailVO';
import Colors from '@domain/constant/colors';
import { ContentRouteUrl, V2Route } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './infoDetailArticleHeader.module.scss';

const cx = classnames.bind(styles);

interface IInfoDetailArticleHeaderProps {
  detailData: InfoDetailVO | null;
}

const InfoDetailArticleHeader = ({ detailData }: IInfoDetailArticleHeaderProps) => {
  if (!detailData) return null;

  const { type, categoryName, title, views, createdDateTime, link, categorySn } = detailData;

  return (
    <header className={cx('header')}>
      <InfoDetailArticleVideo type={type} videoUrl={link} />
      <div className={cx('categoryWrap')}>
        <Link href={ContentRouteUrl.INFO_LIST} legacyBehavior>
          <a className={cx('categoryBtn')}>취업 콘텐츠</a>
        </Link>
        <Icon name="largeArrowRightLight" width={16} height={16} fill={Colors.C_COOL_GRAY_80} />
        <Link href={V2Route.getInfoListPage(categorySn)} legacyBehavior>
          <a className={cx('categoryBtn', 'bold')}>{categoryName}</a>
        </Link>
      </div>
      <strong className={cx('title')}>{title}</strong>

      <div className={cx('snsArea')}>
        <div className={cx('description')}>
          <div className={cx('period')}>
            <div className={cx('text')}>{createdDateTime}</div>
          </div>
          <div className={cx('divider')} />
          <div className={cx('viewCount')}>
            <div className={cx('text')}>{views}</div>
          </div>
        </div>

        <InfoDetailArticleShareGroup
          title={detailData?.title ?? ''}
          label={detailData?.label ?? ''}
          thumbnailUrl={detailData?.thumbnailUrl ?? ''}
        />
      </div>
    </header>
  );
};

export default InfoDetailArticleHeader;
